import { featuresItems, contactContent, cardsItems, appContent, mediaItems } from '@/mocks/homeData';

export function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[960px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-2">平台特色</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">为什么百万吃瓜群众选择51黑料</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featuresItems.map((item) => (
            <div key={item.id} className="bg-background-50 border border-background-200/70 rounded-lg p-6 text-center">
              <div className="w-14 h-14 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-4">
                <i className={`${item.icon} text-2xl text-accent-600`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-800 mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[800px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-2">{contactContent.title}</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">{contactContent.description}</p>
        <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div className="flex items-start gap-4">
              <div className="w-11 h-11 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-xl text-primary-600"></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-1">投稿邮箱</h3>
                <p className="text-sm text-foreground-600">{contactContent.email}</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-11 h-11 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-wechat-line text-xl text-accent-600"></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-1">官方微信</h3>
                <p className="text-sm text-foreground-600">{contactContent.wechat}</p>
              </div>
            </div>
          </div>
          <div className="mt-6 pt-5 border-t border-background-200/70">
            <div className="flex items-start gap-3 bg-accent-50 rounded-md p-4">
              <i className="ri-lightbulb-flash-line text-accent-600 text-lg flex-shrink-0 mt-0.5"></i>
              <p className="text-sm text-foreground-700">{contactContent.tips}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-2">精选推荐</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">编辑部精选 · 最值得一看的黑料内容</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardsItems.slice(0, 6).map((item) => (
            <article key={item.id} className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden group cursor-pointer hover:border-primary-300 transition-colors">
              <div className="aspect-[3/2] bg-background-200 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <span className="inline-block text-xs font-medium text-primary-600 bg-primary-100 px-2 py-0.5 rounded-full mb-2 whitespace-nowrap">{item.tag}</span>
                <h3 className="text-sm font-semibold text-foreground-800 leading-snug mb-3 line-clamp-2">{item.title}</h3>
                <div className="flex items-center gap-4 text-xs text-foreground-400">
                  <span><i className="ri-eye-line mr-1"></i>{item.views}</span>
                  <span className="ml-auto">{item.date}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
        {cardsItems.length > 6 && (
          <div className="mt-6">
            <article className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden flex flex-col sm:flex-row cursor-pointer hover:border-primary-300 transition-colors">
              <div className="sm:w-[280px] flex-shrink-0">
                <div className="aspect-[16/10] sm:aspect-auto sm:h-full bg-background-200">
                  <img
                    src={cardsItems[6].image}
                    alt={cardsItems[6].title}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className="flex-1 p-5 flex flex-col justify-between">
                <div>
                  <span className="inline-block text-xs font-medium text-primary-600 bg-primary-100 px-2 py-0.5 rounded-full mb-2 whitespace-nowrap">{cardsItems[6].tag}</span>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-800 leading-snug mb-2">{cardsItems[6].title}</h3>
                </div>
                <div className="flex items-center gap-4 text-xs text-foreground-400">
                  <span><i className="ri-eye-line mr-1"></i>{cardsItems[6].views}</span>
                  <span className="ml-auto">{cardsItems[6].date}</span>
                </div>
              </div>
            </article>
          </div>
        )}
      </div>
    </section>
  );
}

export function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[960px] mx-auto px-4 md:px-6">
        <div className="bg-background-50 border border-background-200/70 rounded-lg p-8 md:p-10 flex flex-col md:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 text-center md:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">{appContent.title}</h2>
            <p className="text-sm text-primary-600/80 font-medium mb-4">{appContent.subtitle}</p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-5">{appContent.description}</p>
            <ul className="space-y-2 mb-6">
              {appContent.features.map((feat, idx) => (
                <li key={idx} className="flex items-center gap-2 text-sm text-foreground-700">
                  <i className="ri-check-line text-accent-600 flex-shrink-0"></i>
                  {feat}
                </li>
              ))}
            </ul>
            <a
              href="#hero"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-md hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              立即访问移动版
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
          <div className="flex-shrink-0">
            <div className="w-44 h-44 bg-background-200 rounded-lg overflow-hidden">
              <img src={appContent.qrImage} alt="51黑料移动端入口" className="w-full h-full object-cover" loading="lazy" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-2">黑料视频</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">高清实锤视频 · 最直观的吃瓜体验</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaItems.map((item) => (
            <div key={item.id} className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden group cursor-pointer hover:border-primary-300 transition-colors">
              <div className="relative aspect-video bg-background-200 overflow-hidden">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-foreground-950/20 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 bg-foreground-950/70 text-background-50 text-xs px-2 py-0.5 rounded">{item.duration}</span>
                {item.tag && (
                  <span className="absolute top-2 left-2 text-[10px] font-bold bg-primary-500 text-background-50 px-2 py-0.5 rounded-full whitespace-nowrap">{item.tag}</span>
                )}
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-800 leading-snug mb-2 line-clamp-2">{item.title}</h3>
                <span className="text-xs text-foreground-400"><i className="ri-eye-line mr-1"></i>{item.views}次观看</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}